// extracted by mini-css-extract-plugin
export default {"whatsapp-container":"Layout_whatsapp-container__ICfXn","whatsapp-text":"Layout_whatsapp-text__M0ggA","whatsapp":"Layout_whatsapp__rqkAY"};